// This is used to update a community member's wallet.
import firebase from "../../../components/Firebase.js";

export default function CommunityMemberTransaction(
  amount,
  communityWallet,
  description,
  depositDate,
  paymentMethod,
  location,
  collectedDate,
) {
  // Finds today's date.
  const today = new Date().toISOString().split("T")[0];
  const db = firebase.firestore();
  // Load the wallets
  const walletRef = db
    .collection("CommunityWallets")
    .doc(communityWallet.userId); // Assuming userId is the document ID
  // determine if we are deducting or crediting the account.
  const transactionType = amount > 0 ? "credit" : "debit";
  // The amount is all we care about since we have the credit or debit saved.
  const amountAbs = Math.abs(amount);
  // This is the date of the transaction
  const transactionDate = depositDate ?? today;
  // This is the way the user paid etransfer, cash, or N/A
  const paymentMethodTemp = paymentMethod ?? "Not Applicable";

  // Default null/undefined location and collectedDate to empty string
  location = location ?? "";
  collectedDate = collectedDate ?? "";

  // The community wallet.
  const communityWalletTemp = { ...communityWallet };
  // Create the transaction.
  const transaction = {
    transactionType,
    date: transactionDate,
    amount: amountAbs,
    description,
    paymentMethod: paymentMethodTemp,
    location,
    collectedDate,
  };
  // Update the transaction history and the user's total.
  return walletRef
    .update({
      transactionHistory: firebase.firestore.FieldValue.arrayUnion(transaction), // Adds new transaction
      Total: firebase.firestore.FieldValue.increment(amount), // Atomically updates total
    })
    .then(() => {
      // After the transaction has completed it will return the updated object
      // to refresh the page.
      console.log("Transaction successfully added!");
      communityWalletTemp.transactionHistory.push(transaction);
      communityWalletTemp.Total += amount;
      return communityWalletTemp;
    })
    .catch((error) => {
      console.error("Error updating wallet: ", error);
    });
}
